import { StatusModel } from '../general';
import { HexagonListModel } from '../shared/components/hexagon-list';

export interface DeviceModuleMetricsModel {
  utilisation: StatusModel;
  series: HexagonListModel[];
}

export interface ModuleOverViewModel{
  id:string;
  status:
  {
    status:StatusModel;
    unit:string;
    value:number;
    valueInPercent?:number;
  };
  name:string;
  isActive:string;    
}